import { createFileRoute } from "@tanstack/react-router"

import { AdminLayout } from "@/components/layout/admin-layout"
import { requireStaff } from "@/lib/route-guards"

// Staff back office: gates every /admin/* child route in one place (mirrors _authenticated.tsx
// gating the whole app shell). Non-staff are redirected to the dashboard. Layout lives in
// components/layout/admin-layout.tsx so this file exports only the route.
export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: ({ context }) => requireStaff(context, { to: "/dashboard" }),
  component: AdminLayout,
})
